import { DocumentsAPIResponseSchema } from "@/types";
import type { SrpRequestParams } from "hsl-core/SRP";
import { SRP } from "hsl-core/providers";

/**
 * Todo: figure out how to type this properly
 */
// export function useDocuments<T>(
// 	lit_types?: number[],
// 	params?: SrpRequestParams,
// ): T;
// export function useDocuments<T>(
// 	lit_types?: number[],
// 	params?: SrpRequestParams[],
// ): T[];

export function useDocuments(
	lit_types?: number[],
	params?: SrpRequestParams | SrpRequestParams[],
	baseURL?: string,
) {
	const pathname = "/srp/api/documents/";
	const enabled = !!lit_types && lit_types.length > 0;
	return Array.isArray(params)
		? SRP.useSRPMultiple(
				pathname,
				enabled,
				params.map((p) => ({ lit_types, ...p })),
				DocumentsAPIResponseSchema,
				baseURL,
			)
		: SRP.useSRP(
				pathname,
				enabled,
				{ lit_types, ...params },
				DocumentsAPIResponseSchema,
				baseURL,
			);
}

export default useDocuments;
